import React from 'react';
import { Navigate, useNavigate, useParams } from 'react-router-dom';
import { Box, Container, Tabs, Tab, Divider, colors } from '@mui/material';
import Page from 'src/components/Page';
import Header from './Header';
import Timeline from './Timeline';


const styles = {
  root: {},
  container: (theme) => ({
    marginTop: theme.spacing(3)
  }),
  containerDetail: (theme) => ({
    marginTop: theme.spacing(0),
    marginLeft: theme.spacing(8),
    marginRight: theme.spacing(8),
  }),
  divider: {
    backgroundColor: colors.grey[300]
  },
  content: (theme) => ({
    marginTop: theme.spacing(3)
  })
};

function Profile() {
  const navigate = useNavigate();
  const { id, tab: currentTab } = useParams();
  const tabs = [
    { value: 'timeline', label: 'Kullanıcı' },
  ];

  const handleTabsChange = (event, value) => {
    navigate(value);
  };

  if (!currentTab) {
    return <Navigate to={`/profile/${id}/timeline`} replace />;
  }

  if (!tabs.find((tab) => tab.value === currentTab)) {
    return <Navigate to="/errors/error-404" replace />;
  }

  return (
    <Page style={styles.root} title="Kullanıcı">
      <Header />
      <Container maxWidth="xl" >
        <Tabs
          onChange={handleTabsChange}
          scrollButtons="auto"
          value={currentTab}
          variant="scrollable"
          textColor="secondary"
          indicatorColor="primary"
        >
          {tabs.map((tab) => (
            <Tab
              key={tab.value}
              label={tab.label}
              value={tab.value}
            />
          ))}
        </Tabs>
        <Divider sx={styles.divider} />
        <Box sx={styles.content}>
          {currentTab === 'timeline' && <Timeline />}
        </Box>
      </Container>
    </Page>
  );
}

export default Profile;
